<template>
  <Modal
  v-model="isShow"
  :width="640"
  :loading="loading"
  :mask-closable="false"
  @on-ok="ok"
  >
    <h3 slot="header" class="modal-header">修改目标</h3>
    <Form
        style="margin-top:24px"
        ref="searchData"
        :model="searchData"
        :rules="ruleValidate"
        :label-width="84"
        v-if="searchData"
        class="modalbox"
        >
      <Row>
        <Col span="10">
          <FormItem prop="projectFid" label="项目名称">
            <Select v-model="searchData.projectFid" placeholder="项目名称" @on-change="getProjectName">
              <!-- <Option value=''>请选择</Option> -->
              <Option v-for="(item,index) in projectList" :key="'s2'+index" :value="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem prop="estimationType" label="类型">
            <Select v-model="searchData.estimationType" placeholder="类型" @on-change="getConditionList">
              <!-- <Option value=''>请选择</Option> -->
              <Option v-for="(item,index) in typeList" :key="item.value+index" :value="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="10">
          <FormItem prop="itemCode" label="费用项">
            <Select v-model="searchData.itemCode" placeholder="费用项" @on-change="getBudgetCodeList">
              <!-- <Option value=''>请选择</Option> -->
              <Option v-for="(item,index) in conditionList" :key="item.value+index" :value="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem prop="subjectCode" label="预算项">
            <Select v-model="searchData.subjectCode" placeholder="预算项" @on-change="getSubjectName">
              <!-- <Option value=''>请选择</Option> -->
              <Option v-for="(item,index) in budgetCodeList" :key="item.budgetItemCode+index" :value="item.budgetItemCode">{{item.budgetItemName}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="10">
          <FormItem prop="targetAmount" label="目标值">
            <Input v-model="searchData.targetAmount" :number="true" type="text" placeholder="目标金额">
              <span slot="append" v-show="searchData.estimationType == 5">%</span>
            </Input>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem prop="incomeMethod" label="拆分方式">
            <Select v-model="searchData.incomeMethod" placeholder="拆分方式" >
              <!-- <Option value=''>请选择</Option> -->
              <Option v-for="(item,index) in chaifenList" :key="'s1'+index" :value="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormItem prop="timeArr" label="起止日期"  v-if="searchData.estimationType<4">
            <Date-picker style="width:410px!important" v-model="searchData.timeArr" placeholder="起止日期" split-panels type="daterange"></Date-picker>
          </FormItem>
           <FormItem prop="startDate" label="起止日期"  v-if="searchData.estimationType >= 4">
            <Date-picker style="width:410px!important" v-model="searchData.startDate" placeholder="起止日期" type="month"></Date-picker>
          </FormItem>
        </Col>
      </Row>
    </Form>
  </Modal>
</template>

<script>
import { updateTarget,condition,getBudgetCode } from 'api/targetApi'
import {deepClone,formatDateTime} from "../../../../utils/format";

export default {
  props:{
		item:{
			type:Object,
			default:null,
		},
    m: {
      type: Number,
      default: 0
    },
    projectList:{
      type: Array,
      default(){
        return []
      }
    },
    typeList:{
      type:Array,
      default(){
        return []
      }
    },
    chaifenList:{
      type:Array,
      default(){
        return []
      }
    },
	},
  data(){
    const validates = (rule, value, callback) => {
      if (!value[0]) {
        callback(new Error('请选择起止日期'));
      } else{
        callback();
      }
    };
    const validates2 = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择起止月份'));
      } else{
        callback();
      }
    };
    return{
      budgetCodeList:[],
      conditionList:[],
			searchData:deepClone(this.item),
      isShow: false,
      loading:true,
      ruleValidate:{
        projectFid: [
          { required: true, message: '请选择项目名称', trigger: 'change',type:'string'}
        ],
        estimationType:[
          { required: true, message: '请选择类型', trigger: 'change',type:'number'}
        ],
        itemCode:[
          { required: true, message: '请选择业务名称', trigger: 'change', type:'string'}
        ],
        subjectCode:[
          { required: true, message: '请选择预算项', trigger: 'change', type:'string'}
        ],
        targetAmount:[
          { required: true, message: '请输入目标金额', trigger: 'blur', type:'number'}
        ],
        incomeMethod:[
          { required: true, message: '请选择拆方式', trigger: 'change', type:'number'}
        ],
        timeArr:[
          { required: true, message: '请选择起止日期', trigger: 'change', type:'array',validator:validates}
        ],
        startDate:[
          { required: true, message: '请选择起止日期', trigger: 'change', validator:validates2}
        ]
      }
    }
  },
  watch:{
    m(){
      this.$refs['searchData'].resetFields();
      this.searchData = deepClone(this.item);
      this.searchData.timeArr = [this.searchData.startDate,this.searchData.endDate]
      this.searchData.startDate = new Date(this.searchData.startDate)
      this.isShow = true
    }
  },
  computed:{
    saveParams(){
      function f(data) {
        return data?formatDateTime(data, false):''
      }
      let year,month,GOPEndDate
      if(this.searchData.estimationType >= 4){
        year = this.searchData.startDate.getFullYear();
        month = this.searchData.startDate.getMonth()+1;
        GOPEndDate = formatDateTime(new Date(year,month,0),false)
      }
      return {
        fid: this.searchData.fid,
        projectFid: this.searchData.projectFid,
        projectName: this.searchData.projectName,
        estimationType:this.searchData.estimationType,
        itemCode:this.searchData.itemCode,
        itemName:this.searchData.itemName,
        subjectCode:this.searchData.subjectCode,
        subjectName:this.searchData.subjectName,
        targetAmount:this.searchData.targetAmount,
        incomeMethod:this.searchData.incomeMethod,
        startDate:this.searchData.estimationType>=4?f(this.searchData.startDate):f(this.searchData.timeArr[0]),
        endDate:this.searchData.estimationType>=4?GOPEndDate:f(this.searchData.timeArr[1]),
        contractCode:this.searchData.contractCode,
        supplierName:this.searchData.supplierName,
      }
    }
  },
  methods:{
    getProjectName(value){
      this.projectList.forEach( ele => {
        if(ele.value === value){
          this.searchData.projectName = ele.text
        }
      })
    },
    getBudgetCodeList(value){
      if(value == ''){
        this.budgetCodeList = [];
        return false
      }
      this.conditionList.forEach(ele => {
        if(ele.value === value){
          this.searchData.itemName = ele.text
        }
      })
      getBudgetCode({
        busFeeCode:value
      })
      .then( res => {
        this.budgetCodeList = res.data;
        if(res.data.length == 1) {
          this.searchData.subjectCode = res.data[0].budgetItemCode
        }else {
          this.searchData.subjectCode = '';
        }
      })
    },
    getConditionList(value){
      if(!value){
        this.conditionList = []
        return
      }
      condition({
        type:value
      })
      .then( res => {
        this.conditionList = res.data;
        if(res.data.length == 1) {
          this.searchData.itemCode = res.data[0].value;
           this.getBudgetCodeList(res.data[0].value,target);
        }else {
          this.searchData.itemCode = '';
        }
      })
    },
    getSubjectName(value){
      this.budgetCodeList.forEach(ele => {
        if(ele.budgetItemCode === value){
          this.searchData.subjectName = ele.budgetItemName
        }
      })
    },
    changeLoading(){
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true
      })
    },
    ok(){
      this.$refs['searchData'].validate( bool => {
        if(bool){
          let params = {
            ...this.saveParams
          }
          updateTarget(params)
          .then( res => {
            if(res.code === 0){
              this.$Message.success('保存成功')
              this.$emit('done')
            } else{
              this.$Message.error('保存失败')
            }
          })
          .catch( error => {
            this.$Message.error('保存失败')
          })
          .finally(()=>{
            this.isShow = false
          })
        } else{
          this.changeLoading();
        }
      })
    }

  }
}
</script>

<style>
 .modalbox .ivu-input-group-append{
    padding: 0;
  }
  .modalbox .ivu-input-group-append span{
    padding: 4px 7px;
  }
</style>
